// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__t7HUe","Open":"SideDrawer_Open__1EknE","Close":"SideDrawer_Close__26456","Logo":"SideDrawer_Logo__269lA"};